<template>
  <div>
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold">
      Master
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" href="/itemlocations">
        ItemLocations
      </Link>
      <span class="text-black-400 font-medium"> / </span>
      {{ form.name }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input
            v-model="form.name"
            :error="form.errors.name"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Name" />
          <select-input
            v-model="form.ref_area_project_id"
            :error="form.errors.ref_area_project_id"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Area Project">
            <option
              v-for="areaproject in areaprojects"
              :key="areaproject.id"
              :value="areaproject.id">
              {{ areaproject.code+" - "+areaproject.location }}
            </option>
          </select-input>
          <textarea-input
            v-model="form.desc"
            :error="form.errors.desc"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Description" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button
            v-if="!itemlocation.deleted_at"
            class="text-red-600 hover:underline"
            tabindex="-1"
            type="button"
            @click="destroy">
            Delete ItemLocation
          </button>
          <loading-button
            :loading="form.processing"
            class="btn-indigo ml-auto"
            type="submit">
            Update ItemLocation
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TextareaInput,
    },
    layout: Layout,
    props: {
        areaprojects: Object,
        itemlocation: Object,
    },
    remember: 'form',
    data () {
        return {
            form: this.$inertia.form({
                ref_area_project_id: this.itemlocation.ref_area_project_id,
                name: this.itemlocation.name,
                desc: this.itemlocation.desc,
            }),
        }
    },
    methods: {
        update () {
            this.form.put(`/itemlocations/${this.itemlocation.id}`)
        },
        destroy () {
            if (confirm('Are you sure you want to delete this itemlocation?')) {
                this.$inertia.delete(`/itemlocations/${this.itemlocation.id}`)
            }
        },
        restore () {
            if (confirm('Are you sure you want to restore this itemlocation?')) {
                this.$inertia.put(`/itemlocations/${this.itemlocation.id}/restore`)
            }
        },
    },
}
</script>
